<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄 Cooperative Societies Under Liquidation
                    </h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="targetForm" (ngSubmit)="GetSocietyAndLiquidationData()">
                        <div class="row align-items-end">
                                 <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>

                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                        {{ circle?.sBlockName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>

                            <!-- Financial Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Financial/Reporting Year <span
                                        class="text-danger">*</span></label>
                                <select class="form-control" formControlName="financialYear">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let years of financialYears" [ngValue]="years">
                                        {{ years?.financialYear }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                    class="text-danger small">
                                    Financial year is required
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                    Get Report
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between gap-1">
                        <h5 class="font-medium m-0">📄 Reports</h5>
                        <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
  
                            data-bs-target="#CooperativeSocietiesUnderLiquidationDataModal" (click)="addData()"  *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">Add Data for {{currentMonth?.name}}</button>

                        <!-- Modal -->
                        <div class="modal fade" id="CooperativeSocietiesUnderLiquidationDataModal"
                            data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                            aria-labelledby="CooperativeSocietiesUnderLiquidationDataModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5"
                                            id="CooperativeSocietiesUnderLiquidationDataModalLabel">Add Cooperative
                                            Societies Under Liquidation Data</h1>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="closeModel()"></button>
                                    </div>
                                    <div class="modal-body">

                                        <form [formGroup]="societiesForm" novalidate>
                                            <div class="row">

                                                <!-- Financial Year -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Financial/Reporting Year <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="financialYear">
                                                        <option value="">--Select--</option>
                                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                                            {{ years?.financialYear }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="societiesForm.get('financialYear')?.touched && societiesForm.get('financialYear')?.invalid"
                                                        class="text-danger small">
                                                        Financial year is required
                                                    </div>
                                                </div>


                                                <!-- Block Office -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Block Office <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" formControlName="blockOffice">
                                                        <option value="" selected>--Select--</option>
                                                        <option *ngFor="let circle of blockList"
                                                            [value]="circle?.iBlockId">
                                                            {{ circle?.sBlockName }}
                                                        </option>
                                                    </select>
                                                    <div *ngIf="societiesForm.get('blockOffice')?.touched && societiesForm.get('blockOffice')?.invalid"
                                                        class="text-danger small">
                                                        block Office is required
                                                    </div>
                                                </div>


                                                <!-- During Month -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">During Month <span
                                                            class="text-danger">*</span></label>
                                                    <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                                    <select class="form-control" formControlName="dataMonth">
                                                        <option value="" selected>--Select Month--</option>
                                                        <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                            {{ month?.sMonthName }}
                                                        </option>
                                                    </select>

                                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                                        <span
                                                            *ngIf="societiesForm.get('dataMonth')?.touched && societiesForm.get('dataMonth')?.invalid">
                                                            This field is required
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Societies U/L as on 01 {{currentMonth?.name}}<sup
                                                            class="text-danger">*</sup></label>
                                                    <input type="text" class="form-control"
                                                        formControlName="societiesULStart"  />
                                                </div>


                                                <!-- Editable Fields -->
                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Societies put U/L during {{currentMonth?.name}}<sup
                                                            class="text-danger">*</sup></label>
                                                    <input type="text" class="form-control"
                                                        formControlName="societiesPutUL" />
                                                    <div *ngIf="f['societiesPutUL'].touched && f['societiesPutUL'].invalid"
                                                        class="text-danger small">
                                                        <div *ngIf="f['societiesPutUL'].errors?.['required']">This field
                                                            is required.</div>
                                                        <div *ngIf="f['societiesPutUL'].errors?.['pattern']">Only
                                                            numeric values allowed.</div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Societies Wound Up during {{currentMonth?.name}}<sup class="text-danger">*</sup></label>
                                                    <input type="text" class="form-control"
                                                        formControlName="societiesWoundUp" />
                                                    <div *ngIf="f['societiesWoundUp'].touched && f['societiesWoundUp'].invalid"
                                                        class="text-danger small">
                                                        <div *ngIf="f['societiesWoundUp'].errors?.['required']">This
                                                            field is required.</div>
                                                        <div *ngIf="f['societiesWoundUp'].errors?.['pattern']">Only
                                                            numeric values allowed.</div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4 col-md-6 mb-2">
                                                    <label class="form-label">Societies Revived during {{currentMonth?.name}}<sup
                                                            class="text-danger">*</sup></label>
                                                    <input type="text" class="form-control"
                                                        formControlName="societiesRevived" />
                                                    <div *ngIf="f['societiesRevived'].touched && f['societiesRevived'].invalid"
                                                        class="text-danger small">
                                                        <div *ngIf="f['societiesRevived'].errors?.['required']">This
                                                            field is required.</div>
                                                        <div *ngIf="f['societiesRevived'].errors?.['pattern']">Only
                                                            numeric values allowed.</div>
                                                    </div>
                                                </div>

                                                <!-- Pendency Section -->
                                                <div class="col-lg-12">
                                                    <label class="form-label">Pendency of Remaining U/L Societies<sup
                                                            class="text-danger">*</sup></label>
                                                    <div class="row bg-primary-subtle p-3 rounded">

                                                        <div class="col-lg-4 mb-2">
                                                            <label class="form-label">Less than 2 Years<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                formControlName="pendencyLessThan2Years" />
                                                            <div *ngIf="f['pendencyLessThan2Years'].touched && f['pendencyLessThan2Years'].invalid"
                                                                class="text-danger small">
                                                                <div
                                                                    *ngIf="f['pendencyLessThan2Years'].errors?.['required']">
                                                                    This field is required.</div>
                                                                <div
                                                                    *ngIf="f['pendencyLessThan2Years'].errors?.['pattern']">
                                                                    Only numeric values allowed.</div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-4 mb-2">
                                                            <label class="form-label">2 to 5 Years<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                formControlName="pendency2To5Years" />
                                                            <div *ngIf="f['pendency2To5Years'].touched && f['pendency2To5Years'].invalid"
                                                                class="text-danger small">
                                                                <div *ngIf="f['pendency2To5Years'].errors?.['required']">
                                                                    This field is required.</div>
                                                                <div *ngIf="f['pendency2To5Years'].errors?.['pattern']">Only
                                                                    numeric values allowed.</div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-4 mb-2">
                                                            <label class="form-label">Above 5 Years<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                formControlName="pendencyAbove5Years" />
                                                            <div *ngIf="f['pendencyAbove5Years'].touched && f['pendencyAbove5Years'].invalid"
                                                                class="text-danger small">
                                                                <div
                                                                    *ngIf="f['pendencyAbove5Years'].errors?.['required']">
                                                                    This field is required.</div>
                                                                <div
                                                                    *ngIf="f['pendencyAbove5Years'].errors?.['pattern']">
                                                                    Only numeric values allowed.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </form>


                                    </div>
                                    <div class="modal-footer">
                                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModel()">Close</button>
                                <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">


                        <table class="table table-bordered table-hover">
  <thead>
    <tr>
       <th>S.No.</th>
      <th>Month</th>
      <th class="text-end">Societies U/L at the beginning of month</th>
      <th class="text-end">Societies put U/L during the month</th>
      <th class="text-end">Societies Wound Up during the month</th>
      <th class="text-end">Societies Revived during the month</th>
      <th class="text-end">Balance</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of societiesData; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ getMonthName(row.monthId)}}, {{ getYearFromFinancialYear(row.financialYear, row.dataMonth) }}</td>
      <td class="text-end">{{ row.societyUL }}</td>
      <td class="text-end">{{ row.societyPutUL }}</td>
      <td class="text-end">{{ row.societyWoundUP }}</td>
      <td class="text-end">{{ row.societyRevived }}</td>
      <td class="text-end">{{ calculateBalance(row) }}</td>
      <td>
        <ng-container *ngIf="!row.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
         <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
               (click)="editRow(row)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button type="button" class="btn btn-success btn-sm" title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
               data-bs-toggle="modal" data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-clipboard2-check"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm" title="Click to Delete" 
               data-bs-toggle="modal"  data-bs-target="#deleteConfirmModal"
                                                (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-trash3"></i>
            </button>
          
        </ng-container>
        <ng-template #verifiedBlock>
          <button type="button" class="btn btn-primary btn-sm" title="Verified">
            <i class="bi bi-lock"></i>
          </button>
        </ng-template>
      </td>
    </tr>
  </tbody>
</table>

<!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteLiquiditionData(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
             
                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Verification</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyLiquiditionData(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>